// French translations for src/config/release-notes.md.
// Keys are version strings (e.g. '0.2.0'). Values are the full translated
// section markdown including the ### heading line.
// Missing versions fall back to the English source automatically.

export const releaseNotesFr: Record<string, string> = {
  '0.2.0': `### 0.2.0 — Artefacts

Un nouveau mécanisme de fin de partie dont les avantages et inconvénients sont à peser soigneusement.

- **Introduction des Artefacts** — lâchés par les boss après l'Ascension 5, avec plus de lignes de modificateurs à des niveaux de boss plus élevés. Chaque artefact porte un modificateur positif et un négatif — pesez-les avant de les équiper.
- **Meilleure progression inactive** — meilleure gestion des images pour éviter les pics de dégâts et de soins qui pouvaient causer des morts inattendues
- **Jamais terminé** — nombreuses petites corrections de bugs et améliorations de l'interface`,
}
